export default "__VITE_PUBLIC_ASSET__317ce1a1__"